const CONFIG_SECTION = {
  tenant: "tenant",
  purchase: "purchase",
  redemption: "redemption"
}

export default CONFIG_SECTION;
